import { useEffect, useRef, useState } from 'react';
import { getCurrentBreakpoint } from '../styles/themeUtility';

const isDesktopDevice = (breakpoint: string) => ['xl', '2xl'].includes(breakpoint);

export const useWindowDimensions = () => {
  const prevBreakpoint = useRef(getCurrentBreakpoint());
  const [isMobile, setIsMobile] = useState(getCurrentBreakpoint() === 'sm');
  const [isDesktop, setIsDesktop] = useState(isDesktopDevice(getCurrentBreakpoint()));
  const [isTablet, setIsTablet] = useState(getCurrentBreakpoint() === 'md');

  const [isBreakpointChanged, setIsBreakpointChanged] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const currentBreakpoint = getCurrentBreakpoint();
      setIsMobile(currentBreakpoint === 'sm');
      setIsDesktop(isDesktopDevice(currentBreakpoint));
      setIsTablet(currentBreakpoint === 'md');
      setIsBreakpointChanged(prevBreakpoint.current !== currentBreakpoint);
      prevBreakpoint.current = currentBreakpoint;
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile, isDesktop, isTablet, isBreakpointChanged]);

  return { isMobile, isDesktop, isTablet, isBreakpointChanged };
};
